/* eslint-disable react-hooks/exhaustive-deps */

import { API, Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { storeApp, storeCarrier, storeHost, storeShipper, storeShipperGroup, storeShipperGroups, storeShippers, storeUser } from './../stores/slice';
import Footer from './Footer';
import { LeftMenu, TopMenu } from './Menu';
import { useIdleTimer } from 'react-idle-timer';
import { FullStory } from '@fullstory/browser';

const awsConnectGetToken = /* GraphQL */ `
	mutation AwsConnectGetToken($input: AWSJSON!) {
		awsConnectGetToken(input: $input)
	}
`;

const AmazonChatWidget = () => {
	const myUser = useSelector(state => state.slice.USER);
	const myShippers = useSelector(state => state.slice.SHIPPERS);
	const name = `${myUser?.name}, ${myShippers[0]?.shipper?.name}` || 'Guest'

	const widgetId = process.env.REACT_APP_ENV === "prod" ? '3c7ce25c-79f7-456c-b68f-91dc0808b472' : '0c8e9f07-9cfb-45e1-9adb-abd7d4e827fa';
	const snippetId = process.env.REACT_APP_ENV === "prod" ?
		'QVFJREFIaWFZYXRVSlpIekdkUUg5YXhZenVQMktKRXNIWTVFQWpBYVErTEdzRnpvZHdFYWd6blcwdVNTdVhNb1FQZWVQUXg0QUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNcVMxZDkyNno3VkN0Q3pFSkFnRVFnQ3NKMnl0NTdSOWY4b1dJRDNad1ZZL2duNlZQZTNadlFlVGltblVIQ0g3dlhhVXJKdm5tUkFOYi9ubDU6OnhmRllJZlF1WFcvd05CQlZzRmxTZ20vT2FMeFRoRU54MHNkbHBSSWpSajMyMmZLODdXRkRVQTlPREpnT0RsdTJPNjYvSEZpZUhwaVBKTFV0dWRDaUdRY28rKy9kZjc0ckRVOTFjZWlUN1YwZlJzT2gzNXlhTGp0WVAyaGpqN0ZRYTBmTG5BZmtkekF1ak8wdFN1cUZNd25aL3JjeUdOVT0=' :
		'QVFJREFIaXdlaTllQXR1SnQyK1JZc1Z3dWE3clBZQjQvWm15emlVb25scEltc3BJNmdHVVlUSXhxT1pPTGd0dGw1dFVyRTJuQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNMEkzSmxFUGlDaGZzejV2TUFnRVFnQ3NaUkhvamZIemdONjAvREJDbWRVZ2tRT0RBZENxaGQxamIrU3JHQ3R5WEV6aEgxRUZzNlhmMmVlQ286OnpObzIxQS9yQmk2K201THFaNGlaZ2VRMUJKYU0vOWYrWmR1VE1yQ01ta2g4b2J5OUNUL0tIM2w1bk5LSldRVHBUZS9GdllWOW5PcmxiNXYrNjBERHliWkZWd043NkFsZit5Y25TaFN1emFiWlJsaWZzR1N6RTEzcHA4WjRpUFNKNU9rdTZkejFlMkphaGFVZUNseSt3dU1MWXhkTHJIdz0=';
	const scriptSrc = 'https://dtn7rvxwwlhud.cloudfront.net/amazon-connect-chat-interface-client.js';

	const generateToken = async () => {
		try {
			const { data } = await API.graphql({
				query: awsConnectGetToken,
				variables: { input: JSON.stringify({ userId: myUser?.id, type: "SHIPPER" }) }
			});
			const tokenData = JSON.parse(data?.awsConnectGetToken)?.body;
			return tokenData
		} catch (error) {
			console.error('Failed to generate token:', error);
		}
	};

	const removeExistingScript = () => {
		const existingScript = document.getElementById(widgetId);
		if (existingScript) existingScript.remove();
	};

	const connectToAmazon = () => {
		if (!snippetId) return;

		if (document.getElementById(widgetId)) return;


		window.amazon_connect = window.amazon_connect || function () {
			(window.amazon_connect.ac = window.amazon_connect.ac || []).push(arguments);
		};

		const script = document.createElement('script');
		script.id = widgetId;
		script.src = scriptSrc;
		script.async = true;
		script.onerror = (e) => console.error('Amazon Connect script failed to load.', e);

		// Wait for window.amazon_connect to initialize
		const waitForInit = () => {
			if (typeof window.amazon_connect !== 'function') {
				setTimeout(waitForInit, 50);
			} else {
				window.amazon_connect('authenticate', async (cb) => {
					const token = await generateToken();
					return cb(token)
				});
				window.amazon_connect('customerDisplayName', (cb) => cb(name || 'Guest'));

				window.amazon_connect('styles', {
					iconType: 'CHAT',
					openChat: { color: '#ffffff', backgroundColor: '#123456' },
					closeChat: { color: '#ffffff', backgroundColor: '#123456' },
				});

				window.amazon_connect('snippetId', snippetId);
				window.amazon_connect('supportedMessagingContentTypes', [
					'text/plain',
					'text/markdown',
					'application/vnd.amazonaws.connect.message.interactive',
					'application/vnd.amazonaws.connect.message.interactive.response',
				]);

				window.amazon_connect('logLevel', 'debug');
				window.amazon_connect('contactAttributes', JSON.stringify({
					customerName: name || 'Guest',
				}));
				window.amazon_connect('initialMessage', 'Hello');
			}
		};

		waitForInit();
		document.head.appendChild(script);
	};

	useEffect(() => {
		if (myUser?.id) {
			removeExistingScript();
			connectToAmazon();
		}
	}, [myUser?.id]);

	return null;
};


const AdminLayout = () => {

	const dispatch = useDispatch()
	const location = useLocation();
	const navigate = useNavigate();

	const searchParams = new URLSearchParams(location.search);
	const isFullscreen = searchParams.get('fullscreen');
	const [fullScreen, setFullScreen] = useState(false);

	useEffect(() => getSessionData(), [])

	const getSessionData = () => {
		Auth.currentSession().then((session) => {
			let data = localStorage.getItem('phsp')
			if (data) {
				data = JSON.parse(data);
				dispatch(storeHost(data.HOST));
				dispatch(storeUser(data.USER));
				dispatch(storeApp(data.APP));
				dispatch(storeShipperGroup(data.SHIPPER_GROUP));
				dispatch(storeShipperGroups(data.SHIPPER_GROUPS));
				dispatch(storeShipper(data.SHIPPER));
				dispatch(storeShippers(data.SHIPPERS));
				dispatch(storeCarrier(data.CARRIER));
				FullStory('setIdentity', {
					uid: data.USER?.id,
					properties: {
						displayName: data?.USER?.name,
						email: data?.USER?.email,
						shipper: data?.SHIPPER?.shipper?.name || data?.SHIPPER?.shipper?.alias,
						role: data?.SHIPPER?.role,
					}
				})
			}
		}).catch((error) => {
			window.location = '/auth/logout'
		})
	}

	const onIdle = () => {
		if (!fullScreen) navigate('/auth/logout');
	}

	useIdleTimer({ onIdle, timeout: 900_000, throttle: 500 })

	const handleFullScreen = () => {

		if (!('fullscreenElement' in document)) {
			console.warn('Full-screen API is not supported in this browser.');
			return;
		}

		const elem = document.documentElement;

		const isFullscreen =
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement;

		if (!isFullscreen) {
			const requestFullScreen =
				elem.requestFullscreen ||
				elem.webkitRequestFullscreen ||
				elem.mozRequestFullScreen ||
				elem.msRequestFullscreen;

			if (requestFullScreen) {
				requestFullScreen.call(elem)
					.then(() => setFullScreen(true))
					.catch(err => console.error(`Error enabling full-screen mode: ${err.message} (${err.name})`));
			}
		} else {
			const exitFullScreen =
				document.exitFullscreen ||
				document.webkitExitFullscreen ||
				document.mozCancelFullScreen ||
				document.msExitFullscreen;

			if (exitFullScreen) {
				exitFullScreen.call(document)
					.then(() => setFullScreen(false))
					.catch(err => console.error(`Error exiting full-screen mode: ${err.message} (${err.name})`));
			}
		}
	};

	useEffect(() => {
		const onFullScreenChange = () => {
			const isFullscreen =
				document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement;

			setFullScreen(!!isFullscreen);
		};

		// Listen for fullscreen change events
		document.addEventListener('fullscreenchange', onFullScreenChange);
		document.addEventListener('webkitfullscreenchange', onFullScreenChange);
		document.addEventListener('mozfullscreenchange', onFullScreenChange);
		document.addEventListener('MSFullscreenChange', onFullScreenChange);

		// Cleanup event listeners on component unmount
		return () => {
			document.removeEventListener('fullscreenchange', onFullScreenChange);
			document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
			document.removeEventListener('mozfullscreenchange', onFullScreenChange);
			document.removeEventListener('MSFullscreenChange', onFullScreenChange);
		};
	}, []);

	return (
		<>
			{
				(isFullscreen || fullScreen) ? <div className='main-content'>
					<Outlet context={{ fullScreen, handleFullScreen }} />
				</div> : <>
					<LeftMenu />
					<div className='main-content'>
						<Outlet context={{ fullScreen, handleFullScreen }} />
						<Footer />
						<AmazonChatWidget />
					</div>
				</>
			}
		</>
	);
};

export default AdminLayout;
